import Core from "@/modules/core/service/Core";
import { getApiIotBaseUrl } from "@/config";

// iot-api-svc is reached via its own domain (API_IOT_BASE_URL), not the main gateway - same
// pattern as Datahub.js's legacy /api/iot/** calls.
const url = {
    totalsCustomer: () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status/totals?customerId={0}`,
    totalsAll     : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status/totals?allCustomers=true`,
    totals        : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status/totals`,
    eventsCustomer: () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status?category={0}&state={1}&customerId={2}`,
    eventsAll     : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status?category={0}&state={1}&allCustomers=true`,
    events        : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status?category={0}&state={1}`,
    recentlyRecoveredCustomer: () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status/recently-recovered?customerId={0}`,
    recentlyRecoveredAll     : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status/recently-recovered?allCustomers=true`,
    site          : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/{0}`,
    recentlyRecovered        : () => `${getApiIotBaseUrl()}/api/iot-v2/sites/by-status/recently-recovered`,
}

// eventType values used by PLgsIterator (STANDSTILL/LONG_STANDSTILL/UNKNOWN all come from
// SiteState.UnitState) - maps each onto the "category" the new iot-api-svc /sites/by-status
// endpoints need alongside that same eventType as their "state" param.
// RECENTLY_RECOVERED ("Anlage wieder aktiv") is handled separately below - it has its own
// dedicated endpoint (a fixed 7-day window, not a plain unitState lookup).
const categoryFor = () => "UNIT_STATE";

export default {
    // Single site incl. liftBox hardware (EIDs, pairTime) and state.liftboxState. liftBox and
    // liftboxState are null for callers below IOT_DASHBOARD_USER.
    site (siteId) {
        return Core.method.get(url.site(), siteId)
    },

    // customerId and allCustomers are mutually exclusive on the backend - a selected customer
    // always takes precedence (matches the "Alle Kunden" switch + customer dropdown UI, where both
    // can technically be set at once; picking a customer narrows to it regardless of the switch).
    // Replaces the old totals()/loadResolvedTotals() pair: unitState counts and
    // recentlyRecoveredCount ("Anlage wieder aktiv", fixed 7-day window - see iot-api-svc) all come
    // back from this one call now.
    totals (customer, allCustomers) {
        if (customer) {
            return Core.method.get(url.totalsCustomer(), customer.id)
        }
        return Core.method.get(allCustomers ? url.totalsAll() : url.totals())
    },

    events (eventType, customer, allCustomers) {
        if (eventType === "RECENTLY_RECOVERED") {
            if (customer) {
                return Core.method.get(url.recentlyRecoveredCustomer(), customer.id)
            }
            return Core.method.get(allCustomers ? url.recentlyRecoveredAll() : url.recentlyRecovered())
        }

        if (customer) {
            return Core.method.get(url.eventsCustomer(), categoryFor(eventType), eventType, customer.id)
        }
        return Core.method.get(allCustomers ? url.eventsAll() : url.events(), categoryFor(eventType), eventType)
    },
}
